(function () {
  'use strict';

  // Mobile menu
  function initMenu() {
    var nav = document.querySelector('[data-tt-nav]');
    if (!nav) return;
    var toggles = document.querySelectorAll('[data-tt-menu-toggle]');
    var burger = document.querySelector('.tt-header__burger');
    function set(open) {
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('tt-menu-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () { set(!nav.classList.contains('is-open')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && !e.target.closest('[data-tt-menu-toggle]')) set(false);
    });
  }

  // Review slider
  function initSliders(root) {
    (root || document).querySelectorAll('[data-tt-slider]').forEach(function (slider) {
      if (slider.__ttInit) return;
      slider.__ttInit = true;
      var slides = slider.querySelectorAll('[data-tt-slide]');
      if (!slides.length) return;
      var i = 0, timer;
      function go(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      function auto() { clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { go(i + 1); }, 7000); }
      var prev = slider.querySelector('[data-tt-prev]');
      var next = slider.querySelector('[data-tt-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); auto(); });
      if (next) next.addEventListener('click', function () { go(i + 1); auto(); });
      auto();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu(); initSliders();
  });
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
})();
